<div class="breadcrumbs overlay">
    <div class="container">
        <div class="bread-inner">
            <div class="row">
                <div class="col-12">
                    <h2>QUI SOMMES-NOUS?</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<br>


<section class="why-choose section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <!-- Start Choose Left -->
                <div class="choose-left"><br>
                    <h3>Qui sommes-nous ?</h3>
                    <p class="description-text">
                        La Cour des Comptes du Bénin est une institution constitutionnelle créée par la Loi organique n°2018-19 du 10 juillet 2018. Elle est l'organe suprême de contrôle des finances publiques de la République du Bénin.
                    </p>

                    <p class="description-text">
                        Indépendante du pouvoir exécutif, elle assure le contrôle a posteriori de la gestion des finances publiques, des comptes des administrations publiques et de tout organisme public ou recevant des fonds publics.
                    </p>

                    <p class="description-text">
                        Elle contribue au renforcement de la transparence et de la responsabilité dans la gestion des deniers publics.
                    </p>

                    <div>
                        <!-- Simple CSS Buttons -->
                        <div class="justify-content-end">
                            <a (click)="goToMission()" href="javascript: void(0);" class="btn btn-primary"
                                rel="noopener">Mission</a>
                        </div>
                    </div>
                </div><br>
                <!-- End Choose Left -->
            </div>
            <div class="col-md-6 d-flex justify-content-center align-items-center mt-2">
                <img src="../../../assets/img/ccb-batiment.jpg" class="img-fluid rounded" alt="Cour des Comptes du Bénin" style="max-height: 350px;">
            </div>
        </div>
    </div>
</section><br>
<br>
